import { produce } from 'immer';

import { ActionType } from './types';

export interface FeedbackState {
  isLoading: boolean;
  error: string | null;
}

const initialState: FeedbackState = {
  isLoading: false,
  error: null,
};

const feedbackReducer = produce((draft: FeedbackState, action) => {
  const { error } = action;
  switch (action.type) {
    case ActionType.ADD_FEEDBACK:
      draft.isLoading = true;
      break;
    case ActionType.ADD_FEEDBACK_FULFILLED:
      draft.isLoading = false;
      break;
    case ActionType.ADD_FEEDBACK_REJECTED:
      draft.isLoading = false;
      draft.error = error.message;
      break;
  }
}, initialState);

export default feedbackReducer;
